export const SignUpLocationMap: {[environment:string]: string} = {
    ai: 'free ai',
    signup: 'free'
}